import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import HomeScreen from "./screens/HomeScreen/index";
import CommunityScreen from "./screens/CommunityScreen";
import LandlordScreen from "./screens/LandlordScreen";
import TenantScreen from "./screens/TenantScreen";
import IndividualScreen from "./screens/IndividualScreen";
import CareerScreen from "./screens/CareerScreen";
import JobFormScreen from "./screens/JobFormScreen";
import JobDescription from "./screens/JobDescriptionScreen";
import CorporateInfoScreen from "./screens/ConporateInfoScreen";
import DashBoardJobApplications from './AdminControl/DashBoard/JobApplications/index';
import DashboardContactForm from './AdminControl/DashBoard/ContactForm/index'
import ApplicationDetails from './AdminControl/DashBoard/JobApplications/components/ApplicationDetail'
import ContactDetails from './AdminControl/DashBoard/ContactForm/components/contactDetails'
import Signup from './AdminControl/DashBoard/Authentication/signup'
import Login from './AdminControl/DashBoard/Authentication/login'
import Verify from './AdminControl/DashBoard/Authentication/verify'
import ForgotPassword from './AdminControl/DashBoard/Authentication/Forgotpassword';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/dashboardjobApplications" element={<DashBoardJobApplications />} />
        <Route path="/dashboardContactForm" element={<DashboardContactForm />} />
        <Route path="/:homeScreen" element={<HomeScreen />} />
        <Route path="/" element={<HomeScreen />} />
        <Route path="/community" element={<CommunityScreen />} />
        <Route path="/landlord" element={<LandlordScreen />} />
        <Route path="/career" element={<CareerScreen />} />
        <Route path="/jobform" element={<JobFormScreen />} />
        <Route path="/tenant" element={<TenantScreen />} />
        <Route path="/individual" element={<IndividualScreen />} />
        <Route path="/jobdesc" element={<JobDescription />} />
        <Route path="/corporate" element={<CorporateInfoScreen />} />
        <Route path="/applicationDetails/:id" element={<ApplicationDetails />} />
        <Route path="/contactDetails/:id" element={<ContactDetails />} />
        {/* <Route exact path="/" element={<DashBoard />} /> */}
        <Route exact path="/dashboardforgotpassword" element={<ForgotPassword />} />
        {(!localStorage.getItem('authtoken')) ?
          <>
            <Route exact path="/dashboard" element={<Login />} />
            <Route exact path="/dashboardsignup" element={<Signup />} />
            <Route exact path="/dashboardverify" element={<Verify />} />
          </>
          : <Route exact path="/dashboard" element={<DashBoardJobApplications />} />

        }
      </Routes>
    </BrowserRouter>
  );
};

export default App;
